import { useEffect } from 'react'

import { useLocation } from '@twisto/hooks'
import type { AnalyticEvent } from '@twisto/utils'
import { analytics } from '@twisto/utils'

type Props = {
  config: Map<string, AnalyticEvent>
}

export const PageVisitAnalytics = ({ config }: Props) => {
  const { pathname } = useLocation()

  useEffect(() => {
    if (!pathname || config.size === 0) {
      return
    }

    const onMountPageEvent = config.get(pathname)

    if (onMountPageEvent) {
      analytics.logEvent(onMountPageEvent)
    }
  }, [config, pathname])

  return null
}
